import PropTypes from 'prop-types';
import readingTime from 'reading-time';

const ReadTime = ({ content }) => {
  const readTime = readingTime(content).text;
  return <span>{readTime}</span>;
};

ReadTime.propTypes = {
  content: PropTypes.string.isRequired,
};

export default ReadTime;
